// DO NOT EDIT -- generated from fs/services/search-settings/visualizationsettings/visualizationsettings.proto

import * as display from '../../webber/frontend/display';
import * as funnelmetrics from '../../../api/metrics/funnelmetrics';
import * as metrics from '../../../api/metrics';
import * as protobuf from '../../../../google/protobuf';
import * as search from '../../../api/search';
import * as segment from '../../../api/segment';

export interface SegmentSettings {
  segmentId?: string;
  segmentDefinition?: segment.SegmentDefinition | null;
  /** A SegmentDefinition and a name, to be used for ad-hoc segments */
  namedSegmentDefinition?: NamedSegmentDefinition | null;
  /** Note: next tag number is 5 */
  segmentScope: search.Scope;
}

export namespace SegmentSettings {
  export enum segment_id_or_definition {
    segmentId = 1,
    segmentDefinition = 3,
    /** A SegmentDefinition and a name, to be used for ad-hoc segments */
    namedSegmentDefinition = 4
  }

  export function segment_id_or_definition_oneof(m: SegmentSettings): { opt: segment_id_or_definition.namedSegmentDefinition, val: NamedSegmentDefinition } | { opt: segment_id_or_definition.segmentDefinition, val: segment.SegmentDefinition } | { opt: segment_id_or_definition.segmentId, val: string } | null {
    if (m.segmentId != null) { return { opt: segment_id_or_definition.segmentId, val: m.segmentId } }
    if (m.segmentDefinition != null) { return { opt: segment_id_or_definition.segmentDefinition, val: m.segmentDefinition } }
    if (m.namedSegmentDefinition != null) { return { opt: segment_id_or_definition.namedSegmentDefinition, val: m.namedSegmentDefinition } }
    return null;
  }
}

export interface NamedSegmentDefinition {
  segmentDefinition: segment.SegmentDefinition | null;
  name: string;
}

export interface TimeRangeComparison {
  canned?: TimeRangeComparison.ComparisonDateRangeID;
  custom?: segment.TimeRange | null;
}

export namespace TimeRangeComparison {
  export enum ComparisonDateRangeID {
    PREVIOUS_PERIOD = 0,
    PREVIOUS_DAY = 1,
    PREVIOUS_WEEK = 2,
    PREVIOUS_MONTH = 3,
    PREVIOUS_QUARTER = 4,
    PREVIOUS_YEAR = 5
  }

  export enum comparison {
    canned = 1,
    custom = 2
  }

  export function comparison_oneof(m: TimeRangeComparison): { opt: comparison.canned, val: TimeRangeComparison.ComparisonDateRangeID } | { opt: comparison.custom, val: segment.TimeRange } | null {
    if (m.canned != null) { return { opt: comparison.canned, val: m.canned } }
    if (m.custom != null) { return { opt: comparison.custom, val: m.custom } }
    return null;
  }
}

export enum TrendFrequency {
  TREND_FREQUENCY_INVALID = 0,
  TREND_FREQUENCY_MINUTELY = 5,
  TREND_FREQUENCY_HOURLY = 2,
  TREND_FREQUENCY_DAILY = 1,
  TREND_FREQUENCY_WEEKLY = 3,
  TREND_FREQUENCY_MONTHLY = 4
}

export interface TrendSettings {
  frequency: TrendFrequency;
  /** @deprecated */
  computePast: boolean;
  /** @deprecated */
  segmentId: string[];
  /** @deprecated */
  conversionId: string[];
  metric?: metrics.Metric | null;
  metricId?: string;
  displayAs: display.Display | null;
  timeRange: segment.TimeRange | null;
  segment: SegmentSettings[];
  dimensionSettings: metrics.DimensionSettings | null;
  timeRangeComparison: TimeRangeComparison | null;
  color: Color;
}

export namespace TrendSettings {
  export enum trend_metric {
    metric = 6,
    metricId = 9
  }

  export function trend_metric_oneof(m: TrendSettings): { opt: trend_metric.metric, val: metrics.Metric } | { opt: trend_metric.metricId, val: string } | null {
    if (m.metric != null) { return { opt: trend_metric.metric, val: m.metric } }
    if (m.metricId != null) { return { opt: trend_metric.metricId, val: m.metricId } }
    return null;
  }
}

export enum Color {
  COLOR_INVALID = 0,
  COLOR_RED = 1,
  COLOR_GREEN = 2,
  COLOR_YELLOW = 3,
  COLOR_DYNAMIC_RED_UP = 4,
  COLOR_DYNAMIC_RED_DOWN = 5
}

export interface SingleNumberSettings {
  /** @deprecated */
  segmentId: string[];
  /** @deprecated */
  conversionId: string[];
  computePast: boolean;
  color: Color;
  metric?: metrics.Metric | null;
  metricId?: string;
  displayAs: display.Display | null;
  timeRange: segment.TimeRange | null;
  segment: SegmentSettings | null;
  timeRangeComparison: TimeRangeComparison | null;
}

export namespace SingleNumberSettings {
  export enum single_number_metric {
    metric = 6,
    metricId = 9
  }

  export function single_number_metric_oneof(m: SingleNumberSettings): { opt: single_number_metric.metric, val: metrics.Metric } | { opt: single_number_metric.metricId, val: string } | null {
    if (m.metric != null) { return { opt: single_number_metric.metric, val: m.metric } }
    if (m.metricId != null) { return { opt: single_number_metric.metricId, val: m.metricId } }
    return null;
  }
}

export interface TrendSteps {
  start: number;
  end: number;
}

export interface ConversionFunnelSettings {
  /** @deprecated */
  conversionId: protobuf.int64;
  /** @deprecated */
  segmentId: string;
  /** @deprecated */
  dateRange: DateRangeSetting | null;
  segment: SegmentSettings[];
  funnelId?: string;
  events?: segment.EventSequence | null;
  dimensionSettings: metrics.DimensionSettings | null;
  dimensionApplication: funnelmetrics.FunnelDimensionApplication | null;
  timeRange: segment.TimeRange | null;
  timeRangeComparison: TimeRangeComparison | null;
  color: Color;
  timeInterval: segment.TimeInterval;
  /**
   * Steps of the funnel selected for trend, by index. Default is all steps
   * [0:len(funnel.events)]. Slice allowed only for trend funnel.
   */
  trendSteps: TrendSteps | null;
}

export namespace ConversionFunnelSettings {
  export enum funnel {
    funnelId = 5,
    events = 6
  }

  export function funnel_oneof(m: ConversionFunnelSettings): { opt: funnel.events, val: segment.EventSequence } | { opt: funnel.funnelId, val: string } | null {
    if (m.funnelId != null) { return { opt: funnel.funnelId, val: m.funnelId } }
    if (m.events != null) { return { opt: funnel.events, val: m.events } }
    return null;
  }
}

/**
 * TODO(chrisjordan): find a shared place to put this and start using it in
 * conversions and segments
 */
export interface DateRangeSetting {
  dateRangeId: DateRangeId;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export enum DateRangeId {
  DATE_RANGE_ID_INVALID = 0,
  DATE_RANGE_ID_TODAY = 1,
  DATE_RANGE_ID_YESTERDAY = 2,
  DATE_RANGE_ID_PAST_WEEK = 3,
  DATE_RANGE_ID_PAST_MONTH = 4,
  DATE_RANGE_ID_PAST_YEAR = 5,
  DATE_RANGE_ID_ALL_TIME = 6,
  DATE_RANGE_ID_CUSTOM = 7,
  DATE_RANGE_ID_PAST_60_MINUTES = 11,
  DATE_RANGE_ID_PAST_3_HOURS = 12,
  DATE_RANGE_ID_PAST_6_HOURS = 13,
  DATE_RANGE_ID_PAST_24_HOURS = 8,
  DATE_RANGE_ID_PAST_90_DAYS = 9,
  DATE_RANGE_ID_SINCE = 10
}

export interface DimensionalitySettings {
  /** @deprecated */
  segmentId: string[];
  /** @deprecated */
  computePast: boolean;
  metric?: metrics.Metric | null;
  metricId?: string;
  displayAs: display.Display | null;
  timeRange: segment.TimeRange | null;
  dimensionSettings: metrics.DimensionSettings | null;
  segment: SegmentSettings | null;
  timeRangeComparison: TimeRangeComparison | null;
  color: Color;
}

export namespace DimensionalitySettings {
  export enum dimensionality_metric {
    metric = 3,
    metricId = 7
  }

  export function dimensionality_metric_oneof(m: DimensionalitySettings): { opt: dimensionality_metric.metric, val: metrics.Metric } | { opt: dimensionality_metric.metricId, val: string } | null {
    if (m.metric != null) { return { opt: dimensionality_metric.metric, val: m.metric } }
    if (m.metricId != null) { return { opt: dimensionality_metric.metricId, val: m.metricId } }
    return null;
  }
}

export interface JourneyMapSettings {
  segment: SegmentSettings[];
  direction: JourneyMapSettings.Direction;
}

export namespace JourneyMapSettings {
  export enum Direction {
    DIRECTION_INVALID = 0,
    DIRECTION_FORWARD = 1,
    DIRECTION_BACKWARD = 2
  }
}

export interface HeatmapSettings {
  segment: SegmentSettings | null;
  device: segment.Device;
  timeRange: segment.TimeRange | null;
  heatmapType: HeatmapSettings.HeatmapType;
  secondaryHeatmapType: HeatmapSettings.ClickType;
  conversionEvent: segment.Event | null;
  groupByElementProperty: string;
  focusElementId?: string;
  focusSelector?: string;
  /**
   * only applies when a focus is set
   * if true, only the focus element/selector will be shown
   * if false, the focus element/selector *and* all applicable descendants will be shown
   */
  focusOnlyOnSelection: boolean;
}

export namespace HeatmapSettings {
  export enum HeatmapType {
    HEATMAP_TYPE_UNSPECIFIED = 0,
    HEATMAP_TYPE_CLICK = 1,
    HEATMAP_TYPE_SCROLL = 2,
    HEATMAP_TYPE_ENGAGEMENT = 3,
    HEATMAP_TYPE_CONVERSION = 4
  }

  /** Matches alexa.ComputeElementStatsRequest.StatsType */
  export enum ClickType {
    CLICK_TYPE_INVALID = 0,
    CLICK_TYPE_ALL_CLICKS = 1,
    CLICK_TYPE_DEAD_CLICKS = 2,
    CLICK_TYPE_ERROR_CLICKS = 3,
    CLICK_TYPE_RAGE_CLICKS = 4
  }

  export enum focus {
    focusElementId = 8,
    focusSelector = 9
  }

  export function focus_oneof(m: HeatmapSettings): { opt: focus.focusElementId, val: string } | { opt: focus.focusSelector, val: string } | null {
    if (m.focusElementId != null) { return { opt: focus.focusElementId, val: m.focusElementId } }
    if (m.focusSelector != null) { return { opt: focus.focusSelector, val: m.focusSelector } }
    return null;
  }
}

export interface RetentionMetricSettings {
  segment: SegmentSettings[];
  dimensionSettings: metrics.DimensionSettings | null;
  timeRange: segment.TimeRange | null;
  timeInterval: segment.TimeInterval;
  /**
   * The return window used for retention trend visualizations.
   * Set to `null` for retention curve visualizations.
   */
  returnWindow: number | null;
  timeRangeComparison: TimeRangeComparison | null;
}

export interface DataTableSettings {
  timeRange: segment.TimeRange | null;
  timeRangeComparison: TimeRangeComparison | null;
  columnSortOptions: DataTableSettings.ColumnSortOptions | null;
  /**
   * Use segments instead
   * 
   * @deprecated
   */
  segment: SegmentSettings | null;
  segments: SegmentSettings[];
}

export namespace DataTableSettings {
  export interface ColumnSortOptions {
    /** The column index to sort by. This is 0-indexed. */
    index: number;
    direction: metrics.SortOrder;
  }
}
